import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import * as XLSX from 'xlsx';
import styles from './TargetInvoiceTableModal.module.css';

const TargetInvoiceTableModal = ({ invoiceData, onClose, title }) => {
  // Lock body scroll
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const formatCurrency = (amount) =>
    '₹' + (amount || 0).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
    });
  };

  const handleExportExcel = () => {
    try {
      const exportData = invoiceData.map((inv) => ({
        'Invoice No':    inv['Invoice No'],
        'Invoice Date':  formatDate(inv['Invoice Posting Date']),
        'Customer Name': inv['Customer Name'],
        'Customer Code': inv['Customer Code'],
        'Item Code':     inv['Item Code'],
        'Description':   inv['Description'],
        'Category':      inv['Category Name'],
        'Line Total':    inv['Line Total'],
        'State':         inv['State'],
        'Region':        inv['Region'],
        'Sales Person':  inv['Sales Employee'],
        'Status':        inv['Status'],
      }));
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Invoice Details');
      XLSX.writeFile(wb, `Invoice_Details_${new Date().toISOString().split('T')[0]}.xlsx`);
    } catch (err) {
      console.error('Error exporting to Excel:', err);
      alert('Failed to export data');
    }
  };

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{title || 'Invoice Details'}</span>
          <button className={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        {/* Body */}
        <div className={styles.modalBody}>
          <div className={styles.toolbar}>
            <div className={styles.recordCount}>
              Total Records: <strong>{invoiceData.length}</strong>
            </div>
            <button className={styles.excelButton} onClick={handleExportExcel}>
              <span>📊</span> Export to Excel
            </button>
          </div>

          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th}>Invoice No</th>
                  <th className={styles.th}>Invoice Date</th>
                  <th className={styles.th}>Customer Code</th>
                  <th className={styles.th}>Customer Name</th>
                  <th className={styles.th}>Item Code</th>
                  <th className={styles.th}>Description</th>
                  <th className={styles.th}>Category</th>
                  <th className={styles.th}>Line Total</th>
                  <th className={styles.th}>State</th>
                  <th className={styles.th}>Region</th>
                  <th className={styles.th}>Sales Person</th>
                  <th className={styles.th}>Status</th>
                </tr>
              </thead>
              <tbody>
                {invoiceData.map((invoice, index) => (
                  <tr key={index} className={styles.tr}>
                    <td className={styles.td}>{invoice['Invoice No']}</td>
                    <td className={styles.td}>{formatDate(invoice['Invoice Posting Date'])}</td>
                    <td className={styles.td}>{invoice['Customer Code']}</td>
                    <td className={styles.td}>{invoice['Customer Name']}</td>
                    <td className={styles.td}>{invoice['Item Code']}</td>
                    <td className={styles.td}>{invoice['Description']}</td>
                    <td className={styles.td}>{invoice['Category Name']}</td>
                    <td className={styles.tdRight}>{formatCurrency(invoice['Line Total'])}</td>
                    <td className={styles.td}>{invoice['State']}</td>
                    <td className={styles.td}>{invoice['Region']}</td>
                    <td className={styles.td}>{invoice['Sales Employee']}</td>
                    <td className={styles.td}>
                      <span className={`${styles.status} ${
                        invoice['Status'] === 'Closed' ? styles.statusClosed : styles.statusOpen
                      }`}>
                        {invoice['Status']}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer */}
        <div className={styles.modalFooter}>
          <button className={styles.closeButton} onClick={onClose}>Close</button>
        </div>

      </div>
    </div>,
    document.body
  );
};

export default TargetInvoiceTableModal;